import { Text } from 'pixi.js';
import { Scene } from '../core/Scene';
import type { SceneManager } from '../core/SceneManager';
import { SceneType } from '../core/SceneType';
import { GAME_WIDTH, GAME_HEIGHT } from '../constants';

export class LoadingScene extends Scene {
  private sceneManager: SceneManager;
  private timer = 0;

  constructor(sceneManager: SceneManager) {
    super();
    this.sceneManager = sceneManager;

    const text = new Text({
      text: 'Loading...',
      style: { fill: 0xffffff, fontSize: 48, fontFamily: 'monospace' },
    });
    text.anchor.set(0.5);
    text.x = GAME_WIDTH / 2;
    text.y = GAME_HEIGHT / 2;
    this.container.addChild(text);
  }

  enter(): void {
    this.timer = 0;
  }

  update(deltaTime: number): void {
    this.timer += deltaTime;
    if (this.timer >= 0.5) {
      this.sceneManager.go(SceneType.Playing);
    }
  }

  exit(): void {
    // nothing to clean up
  }
}
